import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitDonorsLogic } from './hooks/useNonprofitDonorsLogic';
import { NonprofitDonorsForm } from './NonprofitDonorsForm';

export const EddNonprofitDonors = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitDonorsLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.nonprofitDonors.content')}
        textCustomStyle='text-text-main-primary text-[16px] mt-[24px] whitespace-pre-line'
        content={t('organic.nonprofitDonors.title')}
        headingContainerCustomStyle='!mb-[8px]'>
        <NonprofitDonorsForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
